import classNames from "classnames";
import { useContext } from "react";
import { EditModeContext } from "../context/editModeContext";
import useToggle from "../hooks/useToggle";
import { CountingFrom, Value } from "../http/onlyclicksApi";
import styles from "./Setting.module.css";
import SettingsEditorBottomSheet from "./SettingsEditorBottomSheet";

type Mode = "view" | "edit";

interface Props {
  label: string;
  value?: Value<number>;
  unit: string;
  step?: number;
  minValue?: number;
  maxValue?: number;
  mode?: Mode;
  countingFrom: CountingFrom;
  onChange?: (value?: number) => void;
}

const Setting = ({
  label,
  value,
  unit,
  step,
  minValue,
  maxValue,
  mode = "view",
  countingFrom,
  onChange,
}: Props) => {
  const editDialog = useToggle();
  const isEditMode = mode === "edit";
  const isModified = value?.curr !== value?.prev;
  const editMode = useContext(EditModeContext);

  return (
    <>
      <div
        className={classNames(styles.setting, {
          [styles.editMode]: isEditMode,
        })}
        onClick={() => {
          !isEditMode ? editMode.setOpen(true) : editDialog.open();
        }}
      >
        <span className={styles.label}>{label}</span>
        <span className={styles.value}>
          {value?.curr ?? "-"}
          {isModified && <span className={styles.asterisk}>*</span>}
        </span>
        <span className={styles.unit}>{unit}</span>
      </div>
      <SettingsEditorBottomSheet
        label={label}
        value={value}
        unit={unit}
        step={step}
        minValue={minValue}
        maxValue={maxValue}
        isOpen={editDialog.isOpen}
        onClose={editDialog.close}
        onChange={(v) => onChange?.(v)}
        countingFrom={countingFrom}
      />
    </>
  );
};

export default Setting;
